import { Provider } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/provider.pb';
import { ScheduleAvailabilityTypes } from '@frontend/api-schedule-availability';
import { contextFactory } from '@frontend/design-system';
import { CustomMultiSelectInfiniteDropdownOptionType } from '../components/CustomMultiSelectInfiniteDropdown';

export type AddProviderV3ContextType = {
  locationId: string;
  providerDetails: Provider;
  setProviderDetails: (providerDetails: Provider) => void;
  onClose: () => void;
  providerWorkingHours: ScheduleAvailabilityTypes.ScheduleAvailabilityByDayOfWeek;
  setProviderWorkingHours: (providerWorkingHours: ScheduleAvailabilityTypes.ScheduleAvailabilityByDayOfWeek) => void;
  isProviderHoursPageVisible: boolean;
  setIsProviderHoursPageVisible: (isProviderHoursPageVisible: boolean) => void;
  selectedAppointmentTypes: CustomMultiSelectInfiniteDropdownOptionType[];
  setSelectedAppointmentTypes: (selectedAppointmentTypes: CustomMultiSelectInfiniteDropdownOptionType[]) => void;
};

export const [AddProviderV3Context, useAddProviderV3Context] = contextFactory<AddProviderV3ContextType>(
  'useAddProviderV3Context must be used within a AddProviderV3Context'
);
